import React from 'react';
import { Interp, css, toList } from '../../lib/render.jsx';
import { Kruis } from '../Iconen.jsx';

export default function Chat({ v }) {
  if (!v.showChat) return null;
  return (
    <>
      {' '}
      <div data-venster="chat" onPointerDownCapture={v.chatNaarVoren} style={css(v.chatPanelStyle)}>
        {' '}
        {/* De titelbalk waaraan je het venster versleept. Vier handlers, net als bij
            elk ander venster: het slepen komt uit de vensterlaag (logic/venster.js)
            en niet meer uit een eigen kopie in logic/chat.js. */}
        <div
          onPointerDown={v.chatSleepAan} onPointerMove={v.chatSleep}
          onPointerUp={v.chatSleepUit} onPointerCancel={v.chatSleepUit}
          style={css(v.chatHeaderStyle)}
        >
          {' '}
          <span>
            Chat
          </span>
          {' '}
          {v.showChatClose ? (<>
            {' '}
            {/* Padding erop en een even grote negatieve marge eromheen: het raakvlak
                wordt 44 zonder dat het kruisje verschuift. Op de telefoon is dit de
                enige uitgang, want het venster bedekt de knop waarmee je het opende. */}
            <button onClick={v.toggleChat} title="Sluiten" style={{ "border": "none", "background": "transparent", "cursor": "pointer", "color": "var(--ink)", "display": "flex", "padding": "12px", "margin": "-12px", "borderRadius": "12px" }}>
              <Kruis maat={20} />
            </button>
            {' '}
          </>) : null}
          {' '}
        </div>
        {' '}
        <div ref={v.chatScrollRef} style={css(v.chatScrollStyle)}>
          {' '}
          {v.chatEmpty ? (<>
            {' '}
            <div style={css(v.chatEmptyStyle)}>
              Nog geen berichten. Zeg hoi! 👋
            </div>
            {' '}
          </>) : null}
          {' '}
          {toList(v.chatMessages).map((m, $index) => (
            <React.Fragment key={$index}>
              {' '}
              <div style={{ "display": "flex", "flexDirection": "column", "width": "100%" }}>
                {m?.showDay ? (<>
                  <div style={css(v.chatDayStyle)}>
                    <Interp v={m?.dayLabel} />
                  </div>
                </>) : null}
                <div style={css(m?.rowStyle)}>
                  {' '}
                  {m?.hasAvatar ? (<>
                    {' '}
                    <img alt="" src={m?.avatarUrl} style={css(v.chatAvatarStyle)} />
                    {' '}
                  </>) : null}
                  {' '}
                  {m?.noAvatar ? (<>
                    {' '}
                    <span style={css(v.chatAvatarEmptyStyle)} />
                    {' '}
                  </>) : null}
                  {' '}
                  <div style={css(m?.bubbleStyle)}>
                    {' '}
                    {m?.isBuzz ? (<>
                      {' '}
                      <img alt="" src={m?.avatarUrl} title={m?.author} style={css(m?.buzzAvatarStyle)} />
                      {' '}
                    </>) : null}
                    {' '}
                    <div style={css(m?.authorStyle)}>
                      <Interp v={m?.author} />
                    </div>
                    {' '}
                    <div style={css(m?.textStyle)}>
                      {toList(m?.parts).map((p, $index) => (
                        <React.Fragment key={$index}>
                          <span style={css(p?.style)}>
                            <Interp v={p?.t} />
                          </span>
                        </React.Fragment>
                      ))}
                    </div>
                    {' '}
                  </div>
                  {' '}
                </div>
              </div>
              {' '}
            </React.Fragment>
          ))}
          {' '}
        </div>
        {' '}
        {v.showMentionList ? (<>
          {' '}
          <div style={{ "flex": "1 1 auto", "display": "flex", "flexDirection": "column", "gap": "5px", "padding": "8px 10px", "borderTop": "3px solid var(--ink)", "background": "var(--lila)", "minHeight": "0", "overflowY": "auto" }}>
            <div style={{ "fontSize": "11px", "fontWeight": "700", "letterSpacing": ".05em", "textTransform": "uppercase", "color": "var(--tekst-2)" }}>
              <Interp v={v.mentionListTitle} />
            </div>
            {toList(v.mentionOptions).map((o, $index) => (
              <React.Fragment key={$index}>
                <button onClick={o?.onPick} style={{ "display": "flex", "alignItems": "center", "gap": "8px", "border": "2px solid var(--ink)", "borderRadius": "12px", "background": "#fff", "cursor": "pointer", "font": "inherit", "color": "var(--ink)", "padding": "5px 8px", "textAlign": "left", "width": "100%" }} className="gp-h3">
                  <img alt="" src={o?.avatarUrl} style={{ "width": "24px", "height": "24px", "imageRendering": "pixelated", "border": "2px solid var(--ink)", "borderRadius": "8px", "background": "#fff", "display": "block", "flex": "0 0 auto" }} />
                  <span style={{ "fontSize": "14px", "fontWeight": "700", "flex": "1 1 auto", "overflow": "hidden", "textOverflow": "ellipsis", "whiteSpace": "nowrap" }}>
                    <Interp v={o?.name} />
                  </span>
                </button>
              </React.Fragment>
            ))}
          </div>
          {' '}
        </>) : null}
        {' '}
        {v.emojiOpen ? (<>
          {' '}
          {/* Zes kolommen en knoppen van minstens 44px hoog. Met acht kolommen van
              27px hoog waren dit vierentwintig tikdoelen waar een vinger overheen
              schampt in plaats van in raakt. */}
          <div style={{ "flex": "0 0 auto", "display": "grid", "gridTemplateColumns": "repeat(6,1fr)", "gap": "2px", "padding": "8px 10px", "borderTop": "3px solid var(--ink)", "background": "var(--lila)" }}>
            {toList(v.emojis).map((e, $index) => (
              <React.Fragment key={$index}>
                <button onClick={e?.onClick} style={{ "border": "none", "background": "transparent", "cursor": "pointer", "fontSize": "21px", "lineHeight": "1", "minHeight": "44px", "padding": "4px 0", "borderRadius": "8px" }} className="gp-h3">
                  <Interp v={e?.char} />
                </button>
              </React.Fragment>
            ))}
          </div>
          {' '}
        </>) : null}
        {' '}
        <div style={css(v.chatInputRowStyle)}>
          <button onClick={v.toggleEmoji} className="gp-btn" title="Emoji" style={css(v.emojiBtnStyle)}>
            {' '}
            <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="9.2" />
              <path d="M8.5 14.5a4.5 4.5 0 0 0 7 0" />
              <path d="M9 9.5h.01" />
              <path d="M15 9.5h.01" />
            </svg>
            {' '}
          </button>
          <input type="text" value={v.chatInput ?? ''} onInput={v.onChatInput} onKeyDown={v.onChatKey} placeholder="Chat iets..." style={{ "flex": "1 1 auto", "minWidth": "0", "height": "44px", "boxSizing": "border-box" }} />
          <button onClick={v.sendBuzz} className="gp-btn" disabled={v.buzzDisabled} title={v.buzzTitle} style={css(v.buzzBtnStyle)}>
            {' '}
            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.1" strokeLinecap="round" strokeLinejoin="round">
              <path d="M13 2 4.6 12.6a1 1 0 0 0 .8 1.6H11l-1 7.8 8.4-10.6a1 1 0 0 0-.8-1.6H12z" />
            </svg>
            {' '}
          </button>
          <button onClick={v.sendChat} className="gp-btn p" disabled={v.chatSending} title="Versturen" style={{ "flex": "0 0 auto", "width": "44px", "height": "44px", "padding": "0", "justifyContent": "center", "borderRadius": "12px" }}>
            {' '}
            <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round">
              <path d="M20 6 9 17l-5-5" />
            </svg>
            {' '}
          </button>
        </div>
        {' '}
      </div>
      {' '}
    </>
  );
}
